<div class="page-container">
    <div fxLayout="row wrap" fxLayoutAlign="center start" class="container">
        <div fxFlex class="map">
            <ng-component [ngTemplateOutlet]="mapTemplate"></ng-component>

            <div fxLayout="row" class="absolute-wrapper mt-24" fxLayoutAlign="space-between start" style="z-index: 2">
                <div fxLayout="column" class="filter-wrapper mt-24" fxLayoutAlign="start start">
                    <ng-select name="jucCustomerId" [disabled]="saveAssignmentMode"
                               id="jucCustomerId" class="non-zoom-element"
                               placeholder="Bitte Kunden auswählen"
                               [clearable]="false"
                               [(ngModel)]="filter.jucCustomerId"
                               (ngModelChange)="updateJucCustomerIdFilter($event)">
                        <ng-option *ngFor="let customer of customers"
                                   [value]="customer.id">{{ customer.customerName }}
                        </ng-option>
                    </ng-select>

                    <ng-select name="installationPersonEmail" *ngIf="!assignmentMode"
                               id="installationPersonEmail" class="non-zoom-element"
                               [clearable]="false"
                               [(ngModel)]="filter.installationPersonEmail"
                               (ngModelChange)="updateInstallationPersonEmailFilter($event)">
                        <ng-option [value]="'null'">alle</ng-option>
                        <ng-option [value]="'ohne Zuordnung'">ohne Zuordnung</ng-option>
                        <ng-option *ngFor="let serviceTechnician of serviceTechnicians"
                                   [value]="serviceTechnician.email">
                            {{ serviceTechnician.email }}
                        </ng-option>
                    </ng-select>

                    <ng-select name="installationWeekFilter" *ngIf="!assignmentMode"
                               id="installationWeekFilter" class="non-zoom-element"
                               [clearable]="false"
                               [(ngModel)]="filter.installationWeekFilter"
                               (ngModelChange)="updateInstallationWeekFilter($event)">
                        <ng-option *ngFor="let weekFilterOption of installationWeekFilterOptions"
                                   [value]="weekFilterOption.value">
                            {{ weekFilterOption.label }}
                        </ng-option>
                    </ng-select>

                    <ng-select name="statusFilter" *ngIf="!assignmentMode"
                               id="statusFilter" class="non-zoom-element"
                               placeholder="Status auswählen"
                               [clearable]="true"
                               [(ngModel)]="filter.siteStatuses"
                               [multiple]="true"
                               (ngModelChange)="updateSiteStatusesFilter($event)">
                        <ng-option *ngFor="let statusOption of statusOptions"
                                   [value]="statusOption.value">
                            {{ statusOption.label }}
                        </ng-option>
                    </ng-select>

                    <ng-select name="assignmentInstallationPersonEmail" *ngIf="saveAssignmentMode"
                               id="assignmentInstallationPersonEmail" placeholder="Service Techniker aus Liste wählen"
                               [clearable]="true" class="non-zoom-element"
                               [(ngModel)]="assignmentInstallationPersonEmail"
                               (ngModelChange)="updateAssignmentInstallationPersonEmailFilter($event)">
                        <ng-option *ngFor="let serviceTechnician of serviceTechnicians"
                                   [value]="serviceTechnician.email">
                            {{ serviceTechnician.email }}
                        </ng-option>
                    </ng-select>

                    <input type="number" pattern="^\d{1,2}$" [min]="1" [max]="53" class="non-zoom-element"
                           id="assignmentInstallationWeekFilter" placeholder="Kalenderwoche eingeben (z.B. 8)"
                           [ngModel]="assignmentInstallationWeekFilter"
                           (ngModelChange)="updateAssignmentInstallationWeekFilter($event)" *ngIf="saveAssignmentMode">

                    <input type="search" class="non-zoom-element"
                           id="searchFilter" placeholder="Suche (Straße, PLZ, Ort, Zusatzname, Seriennummer)"
                           [ngModel]="filter.searchTerm"
                           (ngModelChange)="updateSearchTextFilter($event)">
                </div>
            </div>

            <div class="absolute-wrapper mb-50" fxLayoutAlign="space-between end" style="z-index: 2">
                <div fxLayout="row" fxLayoutAlign="space-between end" style="width: 100%">
                    <div>
                        <button class="legend-btn" fxLayoutAlign="center center" (click)="showLegend = !showLegend">
                            Legende
                        </button>

                        <div class="legend" *ngIf="showLegend">
                            <div class="legend-head" fxLayoutAlign="space-between center">
                                <h3>Legende</h3>
                                <button type="button" class="close" (click)="showLegend = false">
                                    <i class="ju ju-close"></i>
                                </button>
                            </div>
                            <div class="rows">
                                <div class="legend-item" fxLayoutAlign="start center">
                                    <img class="pin" src="./assets/images/icons/map/unplanned_pin.png">
                                    <span>Ungeplante Installationen</span>
                                </div>
                                <div class="legend-item" fxLayoutAlign="start center">
                                    <img class="pin" src="./assets/images/icons/map/planned_pin.png">
                                    <span>Geplante Installationen</span>
                                </div>
                                <div class="legend-item" fxLayoutAlign="start center">
                                    <img class="pin" src="./assets/images/icons/map/closed_pin.png">
                                    <span>Abgeschlossene Installationen</span>
                                </div>
                                <div class="legend-item" fxLayoutAlign="start center">
                                    <img class="pin" src="./assets/images/icons/map/notes_pin.png">
                                    <span>Kommentar</span>
                                </div>
                                <div class="legend-item" fxLayoutAlign="start center">
                                    <img class="pin" src="./assets/images/icons/map/ongoing_pin.png">
                                    <span>Montierte Gateways</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="isPlanner()" fxLayout="column" class="button-wrapper mt-24">
                        <div *ngIf="assignmentMode" class="number-of-assignments">
                            Ausgewählt: {{ sitesMarkedForAssignment.length }}
                        </div>
                        <button *ngIf="pinEditMode" class="primary non-zoom-element" fxLayoutAlign="center center"
                                (click)="saveNewPosition()">
                            Speichern
                        </button>
                        <button *ngIf="pinEditMode" class="primary non-zoom-element" fxLayoutAlign="center center"
                                (click)="cancelChangePosition()">
                            Abbrechen
                        </button>

                        <button *ngIf="!assignmentMode && !pinEditMode" class="primary non-zoom-element"
                                fxLayoutAlign="center center"
                                [disabled]="!isPlannerAndIsACustomerSelected()"
                                (click)="enableAssignmentMode()">
                            Zuordnung starten
                        </button>
                        <button *ngIf="!assignmentMode && !pinEditMode" class="primary non-zoom-element"
                                fxLayoutAlign="center center"
                                [disabled]="!isPlannerAndIsACustomerSelected()"
                                (click)="openCreateSiteModal()">
                            + Neue Liegenschaft
                        </button>
                        <button *ngIf="assignmentMode" class="secondary non-zoom-element" fxLayoutAlign="center center"
                                (click)="cancelAssigment()">
                            Abbrechen
                        </button>
                        <button *ngIf="assignmentMode && !saveAssignmentMode" class="primary non-zoom-element"
                                fxLayoutAlign="center center"
                                [disabled]="!isAnySiteMarkedForAssignment()"
                                (click)="enableAssignmentSaveMode()">
                            Auswahl zuordnen
                        </button>
                        <button *ngIf="saveAssignmentMode" class="primary non-zoom-element"
                                fxLayoutAlign="center center"
                                [disabled]="!canSitesMarkedForAssignmentBeSaved()"
                                (click)="updateMarkedSites()">
                            Speichern
                        </button>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-site-detail-modal *ngIf="showMap" [modalControl]="modalSiteDetail"
                       [site]="selectedSite" [isPlanner]="isPlanner()"
                       (updatedSite)="onSiteUpdated()" (moveSite)="moveSite($event)">
</app-site-detail-modal>
<app-create-site-detail-modal *ngIf="showMap" [modalControl]="modalCreateSiteDetail" [isPlanner]="isPlanner()"
                              [site]="createSite" (updatedSite)="onSiteUpdated()">
</app-create-site-detail-modal>

<ng-template #mapTemplate>

    <div [style]="'position: absolute; top: 0; bottom: 0; left: 0; right: 0; background-color: black; opacity: 0.3; z-index: 1; display: ' +
     (saveAssignmentMode ? 'block' : 'none')"></div>
    <agm-map #map class="new-map" (zoomChange)="zoomChange($event)" (centerChange)="centerChange($event)"
             (idle)="idle()"
             [disableDefaultUI]="true" [latitude]="latitude" [longitude]="longitude" [zoom]="zoom"
             [fitBounds]="fitBounds"
             [gestureHandling]="'cooperative'" [styles]="mapStyles">
        <agm-marker-spider (format)="formatSpider($event)" *ngIf="showMap">
            <agm-marker
                    *ngFor="let site of sites; trackBy: trackByFn"
                    [agmFitBounds]="fitBounds"
                    (markerClick)="showDetails(site)"
                    [latitude]="site.latitude"
                    [longitude]="site.longitude"
                    [iconUrl]="getMarkerIcon(site)"
                    (mouseOver)="onMouseOver(infoWindow, $event)"
                    (mouseOut)="onMouseOut(infoWindow)"
                    [markerDraggable]="editSite?.id === site.id"
                    [opacity]="editSite?.id && editSite?.id !== site.id ? 0.5 : 1"
                    (drag)="markerDrag($event)"
                    [label]="site.id + ''"
            >
                <agm-info-window #infoWindow [disableAutoPan]="true">
                    {{ site?.street || '-' }} {{ site?.streetNumber || '-' }}
                    , {{ site?.postCode || '-' }} {{ site?.city || '-' }}
                    {{ site?.additionalName ? '- ' + site.additionalName : '' }}
                </agm-info-window>
            </agm-marker>
        </agm-marker-spider>
        <agm-marker *ngIf="currentPosition"
                    [latitude]="currentPosition.lat"
                    [longitude]="currentPosition.lng"
                    [markerDraggable]="false"
                    [opacity]="1"
                    [iconUrl]="$any(currentPositionIcon)"
        ></agm-marker>
    </agm-map>
</ng-template>
